import type { ThemeAIVisibility } from '../types/gotypes'
import { decide, type ActionDecision, type WhoToAsk } from './permissionReason'

/** A Theme AI task or code frame: who owns it, and whether it is Company-level. */
export interface ThemeAIOwnedItem {
  owner: string
  visibility: ThemeAIVisibility
}

/** The person looking at the item. */
export interface ThemeAIViewer {
  email?: string | null
  isManager: boolean
}

/**
 * Mirrors canModifyThemeAITask and canModifyThemeAICodeFrame
 * (goapi/pkg/server/themeai_tasks.go): the owner may change their own item,
 * and a Manager may change a Company-level one.
 */
export const canModifyThemeAIItem = (item: ThemeAIOwnedItem, viewer: ThemeAIViewer): boolean =>
  Boolean(viewer.email && item.owner.toLowerCase() === viewer.email.toLowerCase())
  || (item.visibility === 'exec' && viewer.isManager)

/**
 * ALLOWED, or why not. A colleague's item names its owner. A Company-level
 * item has no one owner to ask (only a Manager changes it), so it names the
 * viewer's team manager.
 */
export const themeAIWriteDecision = (
  item: ThemeAIOwnedItem,
  viewer: ThemeAIViewer,
  cannot: string,
  who: WhoToAsk,
  copy?: string,
): ActionDecision =>
  decide(canModifyThemeAIItem(item, viewer), cannot, who, {
    owner: item.visibility === 'exec' ? undefined : item.owner,
    copy,
  })
